import type { User, UserStatus } from "../types";
import { USER_STATUS, USER_STATUS_SET } from "./constants";
import { ERROR_MESSAGES } from "./messageConstants";


export function toUserStatus(status: string | undefined): UserStatus {
  if (status && USER_STATUS_SET.has(status as UserStatus)) {
    return status as UserStatus;
  }
  return USER_STATUS.ACTIVE as UserStatus;
}

export function isUserOnboardingRequired(
  user: Pick<User, "userStatus" | "dob"> | null | undefined
): boolean {
  if (!user) {
    return false;
  }
  return user.userStatus === USER_STATUS.PENDING && !user.dob?.trim();
}

export function isOnboardingAccountRemovedError(
  message: string,
  statusCode?: number
): boolean {
  if (statusCode === 403) {
    return true;
  }
  const normalized = message.toLowerCase();
  return (
    normalized.includes(ERROR_MESSAGES.ONBOARDING.AT_LEAST_16_YEAR) &&
    normalized.includes(ERROR_MESSAGES.ONBOARDING.ACCOUNT_REMOVED)
  );
}
